<template>
  <div class="w-100 px-5">
    <div class="w-100 mb-5 d-flex justify-content-start align-items-center">
      <h1>cursos</h1>
      <img alt="Akdemica" height="70" class="logo-menu" src="../../assets/img/mascote.png">
    </div>
    <div class="course-items">
      <div v-for="course in courses" :key="course.id" class="col-12 col-md-3 clickable"  @click="goToCourse(course)">
        <img height="200" :src="`${ api_url }${ course.thumbnail.url }`">
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'

export default {
  data () {
    return {
      courses: [],
      api_url: process.env.VUE_APP_ROOT_BASE
    }
  },
  methods: {
    loadCourses: function () {
      Axios.get('/course/list?perpage=4&latest=true')
        .then( res => {
          this.courses = res.data.data
        })
    },
    goToCourse: function (course) {
      window.open(`/cursos/${course.name}/${course.id}/${course.user.name}`, '_blank')
    }
  },
  mounted() {
    this.loadCourses()
  }
}
</script>

<style>

</style>
